import { useQuery } from "@tanstack/react-query";

import { createActivationApi } from "app/pages/activation/services/api";
import type { KeywordTrendsCreationDTO } from "app/pages/activation/types/api";

const KEYWORDS_TRENDS_QUERY_KEY = "KEYWORDS_TRENDS_QUERY_KEY";

export const useGetKeywordsTrendsQuery = (data?: KeywordTrendsCreationDTO) => {
    return useQuery({
        queryKey: [KEYWORDS_TRENDS_QUERY_KEY, data?.campaignguid],
        queryFn: async () => {
            const { rankTracker } = createActivationApi();

            return await rankTracker.getKeywordsTrends(data);
        },
        enabled: !!data,
        refetchOnWindowFocus: false,
        retry: 1,
    });
};
